"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookingTemplateOfferMapper = void 0;
const lodash_1 = __importDefault(require("lodash"));
class BookingTemplateOfferMapper {
    toDomain(result) {
        const { id, name, schedules, zone, bookingOfferTemplate } = lodash_1.default.get(result, "data.pos");
        return {
            pos: {
                id,
                name,
                schedules,
                zone,
                bookingOfferTemplate,
            },
        };
    }
}
exports.BookingTemplateOfferMapper = BookingTemplateOfferMapper;
